import React, { useEffect, useState } from 'react'
import { useGetTeamsQuery } from '../features/team/teamApi'
import { useGetProjectsQuery } from '../features/project/projectApi'
import { useAddTaskMutation } from '../features/task/taskApi'
import { useNavigate } from 'react-router-dom'

export default function AddTaskForm() {
    const navigate = useNavigate()
    const { isSuccess: isSuccessTeams, data: teams } = useGetTeamsQuery()
    const { isSuccess: isSuccessProjects, data: projects, } = useGetProjectsQuery()
    const [addTask, { isSuccess: isSuccessAddTask }] = useAddTaskMutation()

    const [teamMember, setTeamMember] = useState({})
    const [project, setProject] = useState({})
    const [taskName, setTaskName] = useState("")
    const [deadline, setDeadline] = useState("")

    useEffect(() => {
        if (isSuccessAddTask) {
            navigate("/")
        }
    }, [navigate, isSuccessAddTask])


    function handleSubmit(e) {
        e.preventDefault();

        addTask({
            taskName,
            teamMember: JSON.parse(teamMember),
            project: JSON.parse(project),
            deadline,
            status: ""
        })

    }

    return (
        <form onSubmit={handleSubmit} className="space-y-6">
            <div className="fieldContainer">
                <label htmlFor="lws-taskName">Task Name</label>
                <input
                    type="text"
                    name="taskName"
                    id="lws-taskName"
                    required
                    value={taskName}
                    onChange={e => setTaskName(e.target.value)}
                    placeholder="Implement RTK Query"
                />
            </div>

            <div className="fieldContainer">
                <label>Assign To</label>
                <select name="teamMember" id="lws-teamMember" value={teamMember} onChange={e => setTeamMember(e.target.value)} required>
                    <option value="" hidden selected>Select Job</option>
                    {
                        isSuccessTeams && teams.length > 0 ? teams.map(team => <option key={team.id} value={JSON.stringify(team)}>{team.name}</option>) : "Loading..."
                    }
                </select>
            </div>
            <div className="fieldContainer">
                <label htmlFor="lws-projectName">Project Name</label>
                <select id="lws-projectName" name="projectName" value={project} onChange={e => setProject(e.target.value)} required>
                    <option value="" hidden selected>Select Project</option>
                    {
                        isSuccessProjects && projects.length > 0 ? projects.map(project => <option key={project.id} value={JSON.stringify(project)}>{project.projectName}</option>) : "Loading..."
                    }
                </select>
            </div>

            <div className="fieldContainer">
                <label htmlFor="lws-deadline">Deadline</label>
                <input type="date" name="deadline" id="lws-deadline" value={deadline} onChange={e => setDeadline(e.target.value)} required />
            </div>

            <div className="text-right">
                <button type="submit" className="lws-submit">Save</button>
            </div>
        </form>
    )
}
